import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Product} from '../../entities/product';
import {Config} from '../../entities/config';
import {StyleService, StyleType} from '../../services/style.service';

@Component({
    selector: 'app-payment-complete',
    templateUrl: './payment-complete.component.html',
    styleUrls: ['./payment-complete.component.scss'],
})
export class PaymentCompleteComponent implements OnInit, OnDestroy {
    public readonly StyleType = StyleType;

    @Input()
    product: Product;
    paymentType: String;
    remainingVouchers: Number;
    queue_number: Number;
    selectedAdditions: Product[] = [];
    userConfig: Config;

    value: number = 0;
    timer = 10;
    interval;

    orderText = "";

    constructor(
        private modalCtrl: ModalController,
        public styleService: StyleService) { }

    ngOnInit() {
        this.interval = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
                this.dismiss('timer')
            }
        }, 1000)
        
        this.queue_number = Number(String(this.queue_number).slice(-2));

        if (this.product) {
            this.orderText = `${this.product.name || '-'}`;
            if (this.paymentType != 'Kupon')
                this.orderText += ` - ${this.product.price || '-'} kr.`
            if (this.selectedAdditions && this.selectedAdditions.length > 0) {
                this.selectedAdditions.forEach(add => {
                    this.orderText += `, ${add.name || '-'}`;
                    if (this.paymentType != 'Kupon')
                        this.orderText += ` - ${add.price || '-'} kr.`
                })
            }
        }
    }

    ngOnDestroy() {
        clearInterval(this.interval)
    }

    dismiss(status) {
        clearInterval(this.interval)
        this.modalCtrl.dismiss({
            'status': status
        })
    }
}
